"use strict";
/**
 * Moderation canonical-definitions barrel.
 *
 * Re-exports the 12 moderation family template builders and assembles
 * `MODERATION_TEMPLATES` — a map keyed by the moderation `{type}` (the segment after
 * `moderation-`) to its template builder. The setup lambda iterates this map to register
 * every owned moderation family from one canonical source (no inline mappings).
 *
 * Moderation families are REGISTRAR-ONLY: they have NO search-document interface and are
 * NOT read by application search queries, so they expose TEMPLATE BUILDERS ONLY (no
 * `*_FIELDS` constants, no interfaces).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MODERATION_TEMPLATES = exports.buildModerationLinkSuggestionsTemplate = exports.buildModerationCraftRoomTemplate = exports.buildModerationMalwareTemplate = exports.buildModerationPdfTemplate = exports.buildModerationFieldSuggestionsTemplate = exports.buildModerationCommentsTemplate = exports.buildModerationProjectsTemplate = exports.buildModerationPatternsTemplate = exports.buildModerationReviewsTemplate = exports.buildModerationContributionsTemplate = exports.buildModerationAppealsTemplate = exports.buildModerationFlagsTemplate = void 0;
const flags_1 = require("./flags");
const appeals_1 = require("./appeals");
const contributions_1 = require("./contributions");
const reviews_1 = require("./reviews");
const patterns_1 = require("./patterns");
const projects_1 = require("./projects");
const comments_1 = require("./comments");
const field_suggestions_1 = require("./field-suggestions");
const pdf_1 = require("./pdf");
const malware_1 = require("./malware");
const craft_room_1 = require("./craft-room");
const link_suggestions_1 = require("./link-suggestions");
var flags_2 = require("./flags");
Object.defineProperty(exports, "buildModerationFlagsTemplate", { enumerable: true, get: function () { return flags_2.buildModerationFlagsTemplate; } });
var appeals_2 = require("./appeals");
Object.defineProperty(exports, "buildModerationAppealsTemplate", { enumerable: true, get: function () { return appeals_2.buildModerationAppealsTemplate; } });
var contributions_2 = require("./contributions");
Object.defineProperty(exports, "buildModerationContributionsTemplate", { enumerable: true, get: function () { return contributions_2.buildModerationContributionsTemplate; } });
var reviews_2 = require("./reviews");
Object.defineProperty(exports, "buildModerationReviewsTemplate", { enumerable: true, get: function () { return reviews_2.buildModerationReviewsTemplate; } });
var patterns_2 = require("./patterns");
Object.defineProperty(exports, "buildModerationPatternsTemplate", { enumerable: true, get: function () { return patterns_2.buildModerationPatternsTemplate; } });
var projects_2 = require("./projects");
Object.defineProperty(exports, "buildModerationProjectsTemplate", { enumerable: true, get: function () { return projects_2.buildModerationProjectsTemplate; } });
var comments_2 = require("./comments");
Object.defineProperty(exports, "buildModerationCommentsTemplate", { enumerable: true, get: function () { return comments_2.buildModerationCommentsTemplate; } });
var field_suggestions_2 = require("./field-suggestions");
Object.defineProperty(exports, "buildModerationFieldSuggestionsTemplate", { enumerable: true, get: function () { return field_suggestions_2.buildModerationFieldSuggestionsTemplate; } });
var pdf_2 = require("./pdf");
Object.defineProperty(exports, "buildModerationPdfTemplate", { enumerable: true, get: function () { return pdf_2.buildModerationPdfTemplate; } });
var malware_2 = require("./malware");
Object.defineProperty(exports, "buildModerationMalwareTemplate", { enumerable: true, get: function () { return malware_2.buildModerationMalwareTemplate; } });
var craft_room_2 = require("./craft-room");
Object.defineProperty(exports, "buildModerationCraftRoomTemplate", { enumerable: true, get: function () { return craft_room_2.buildModerationCraftRoomTemplate; } });
var link_suggestions_2 = require("./link-suggestions");
Object.defineProperty(exports, "buildModerationLinkSuggestionsTemplate", { enumerable: true, get: function () { return link_suggestions_2.buildModerationLinkSuggestionsTemplate; } });
/**
 * Map of moderation `{type}` -> canonical template builder.
 *
 * Keys are the `{type}` segment after `moderation-` (e.g. `flags` for
 * `moderation-flags`). The setup lambda iterates this map to ensure each owned
 * moderation family's template, sourcing the body from shared-types instead of
 * inlining it.
 */
exports.MODERATION_TEMPLATES = {
    flags: flags_1.buildModerationFlagsTemplate,
    appeals: appeals_1.buildModerationAppealsTemplate,
    contributions: contributions_1.buildModerationContributionsTemplate,
    reviews: reviews_1.buildModerationReviewsTemplate,
    patterns: patterns_1.buildModerationPatternsTemplate,
    projects: projects_1.buildModerationProjectsTemplate,
    comments: comments_1.buildModerationCommentsTemplate,
    'field-suggestions': field_suggestions_1.buildModerationFieldSuggestionsTemplate,
    pdf: pdf_1.buildModerationPdfTemplate,
    malware: malware_1.buildModerationMalwareTemplate,
    'craft-room': craft_room_1.buildModerationCraftRoomTemplate,
    'link-suggestions': link_suggestions_1.buildModerationLinkSuggestionsTemplate,
};
